import { createApiEffect } from '@/features/api/common/create-api-effect'
import { Employee } from '@/features/api/employee/types'

export const getEmployeeByIdFx = createApiEffect<string, Employee>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/user-app/employee/${id}/`,
  }),
})
